import { createContext } from 'react';

import type { ModalsManagerMethods } from './useModalsManager';

export const ModalsContext = createContext<ModalsManagerMethods>({
  getIsActive: () => false,
  setAsActive: () => {},
  setAsInactive: () => {},
  getIsOpen: () => false,
});
